import { Provider } from "react-redux";
import { store } from "@/lib/store";
import { ThemeProvider } from "@/hooks/useTheme";

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <ThemeProvider>{children}</ThemeProvider>
    </Provider>
  );
}
